import React, { useEffect } from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Switch from "react-switch"
import { color } from "echarts"
function AudianceAndTicketing({ validation, onDataChange }) {
  const isBookingEnabled = validation.values.enableTicketBooking
  const isEarlyBirdEnabled = validation.values.enable_early_bird

  const isAudienceSelected = (validation.values.audienceType || []).length > 0

  const isAgeSelected = (validation.values.ageGroup || []).length > 0

  const canEnableTicketBooking = isAudienceSelected && isAgeSelected

  const bookingType = validation.values.bookingType
  const foodCategories = [
    validation.values.enable_veg && "veg",
    validation.values.enable_nonveg && "non_veg",
    validation.values.enable_vegan && "vegan",
  ].filter(Boolean)

  console.log(`---aaa-----${bookingType}`)


  const Offsymbol = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      No
    </div>
  )

  const OnSymbol = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      Yes
    </div>
  )

  useEffect(() => {
    if (onDataChange) onDataChange(validation.values)
  }, [validation.values])

  useEffect(() => {
    if (!canEnableTicketBooking) {
      validation.setFieldValue("enableTicketBooking", false)
    }
  }, [canEnableTicketBooking])

// useEffect(() => {
//   if (!validation.values.bookingType) return;

//   if (validation.values.bookingType === "food_booking") {
//     validation.setFieldValue("ticketPricing", {});
//     validation.setFieldValue("ticketFoodPricing", {});
//   }

//   if (validation.values.bookingType === "ticket_booking") {
//     validation.setFieldValue("foodPricing", {
//       veg: {},
//       non_veg: {},
//       vegan: {},
//     });
//     validation.setFieldValue("ticketFoodPricing", {});
//   }

//   if (validation.values.bookingType === "ticket_food_booking") {
//     validation.setFieldValue("foodPricing", {
//       veg: {},
//       non_veg: {},
//       vegan: {},
//     });
//     validation.setFieldValue("ticketPricing", {});
//   }

// }, [validation.values.bookingType]);

// useEffect(() => {
//   if (!validation.values.bookingType) return;

//   // Reset ALL limits when switching type
//   validation.setValues({
//     ...validation.values,

//     // ticket
//     memberTicketLimit: "",
//     nonMemberTicketLimit: "",

//     // veg
//     memberVegLimit: "",
//     nonMemberVegLimit: "",

//     // non-veg
//     memberNonVegLimit: "",
//     nonMemberNonVegLimit: "",

//     // vegan
//     memberVeganLimit: "",
//     nonMemberVeganLimit: "",
//   });

// }, [validation.values.bookingType]);



useEffect(() => {
  if (!isBookingEnabled) {
    // Reset all booking related fields for a "Free Event"
    validation.setFieldValue("bookingType", "");
    validation.setFieldValue("bookingOpen", "");
    validation.setFieldValue("bookingClose", "");
    validation.setFieldValue("enable_early_bird", false);
    validation.setFieldValue("earlyBirdEndDate", "");
    
    // Clear Limits
    const fieldsToReset = [
      "memberTicketLimit", "nonMemberTicketLimit",
      "memberVegLimit", "nonMemberVegLimit",
      "memberNonVegLimit", "nonMemberNonVegLimit",
      "memberVeganLimit", "nonMemberVeganLimit"
    ];
    
    fieldsToReset.forEach(field => validation.setFieldValue(field, ""));
  }
}, [isBookingEnabled]);


useEffect(() => {
  const type = validation.values.bookingType;

  if (!type) return;

  const setIfEmpty = (field) => {
    if (!validation.values[field]) {
      validation.setFieldValue(field, 6);
    }
  };

  const foodCategories = [
    validation.values.enable_veg && "veg",
    validation.values.enable_nonveg && "non_veg",
    validation.values.enable_vegan && "vegan",
  ].filter(Boolean);

  // ✅ Ticket
  if (type === "ticket_booking" || type === "ticket_food_booking") {
    if (validation.values.isMember) setIfEmpty("memberTicketLimit");
    if (validation.values.isNonMember) setIfEmpty("nonMemberTicketLimit");
  }

  // ✅ Food (ONLY selected categories)
  if (type === "food_booking" || type === "ticket_food_booking") {

    if (validation.values.isMember) {
      if (foodCategories.includes("veg")) {
        setIfEmpty("memberVegLimit");
      }
      if (foodCategories.includes("non_veg")) {
        setIfEmpty("memberNonVegLimit");
      }
      if (foodCategories.includes("vegan")) {
        setIfEmpty("memberVeganLimit");
      }
    }

    if (validation.values.isNonMember) {
      if (foodCategories.includes("veg")) {
        setIfEmpty("nonMemberVegLimit");
      }
      if (foodCategories.includes("non_veg")) {
        setIfEmpty("nonMemberNonVegLimit");
      }
      if (foodCategories.includes("vegan")) {
        setIfEmpty("nonMemberVeganLimit");
      }
    }
  }

}, [
  validation.values.bookingType,
  validation.values.isMember,
  validation.values.isNonMember,
  validation.values.enable_veg,
  validation.values.enable_nonveg,
  validation.values.enable_vegan
]);
  const handleAudienceChange = (field, value, checked) => {
    // Update boolean
    validation.setFieldValue(field, checked)

    // Update array
    const current = validation.values.audienceType || []

    const updated = checked
      ? [...new Set([...current, value])] // prevent duplicates
      : current.filter(v => v !== value)

    validation.setFieldValue("audienceType", updated)
  }

  const handleAgeChange = (field, value, checked) => {
    validation.setFieldValue(field, checked)

    const current = validation.values.ageGroup || []

    const updated = checked
      ? [...new Set([...current, value])]
      : current.filter(v => v !== value)

    validation.setFieldValue("ageGroup", updated)
  }
  return (
    <>

      <div className="d-flex align-items-center mb-4">
        <div className="avatar-sm me-3">
          <span className="avatar-title rounded-circle bg-success bg-soft text-success font-size-18">
            <i className="mdi mdi-account-multiple"></i>
          </span>
        </div>
        <div>
          <h5 className="mb-0 fw-semibold">Audience & Ticketing</h5>
          <small className="text-muted">Define your audience types, age groups and booking settings</small>
        </div>
      </div>

      {/* Audience & Age Groups */}
      <div className="mb-4 border border-primary rounded p-3 bg-light">
        <h6 className="fw-semibold ">
          Audience & Age Configuration
        </h6>
        <Row className="g-3 p-3">
          <Col md={6}>
            <div className="p-3 border border-info bg-info bg-opacity-10 rounded">
              <Label className="fw-semibold mb-3 d-block">
                <i className="mdi mdi-account-group me-2 text-primary"></i>Audience Type
              </Label>
              {[
                { id: "isMember", label: "Member", value: "member", field: "isMember" },
                { id: "isNonMember", label: "Non Member", value: "non_member", field: "isNonMember" },
                // { id: "isSponsor", label: "Sponsor", value: "sponsor", field: "isSponsor" },
              ].map(item => (
                <div key={item.id} className="d-flex align-items-center justify-content-between py-2 border-bottom border-white" onClick={e => e.stopPropagation()}>
                  <Label className="mb-0" htmlFor={item.id}>{item.label}</Label>
                  <Input
                    type="checkbox"
                    id={item.id}
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                    defaultChecked={!!validation.values[item.field]}
                    onChange={e => handleAudienceChange(item.field, item.value, e.target.checked)}
                  />
                </div>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <div className="p-3 border border-info bg-info bg-opacity-10 rounded">
              <Label className="fw-semibold mb-3 d-block">
                <i className="mdi mdi-account-clock me-2 text-info"></i>Age Group
              </Label>
              {[
                { id: "isAdult", label: "Adult", value: "adult", field: "isAdult" },
                { id: "isChild", label: "Child", value: "child", field: "isChild" },
              ].map(item => (
                <div key={item.id} className="d-flex align-items-center justify-content-between py-2 border-bottom border-white" onClick={e => e.stopPropagation()}>
                  <Label className="mb-0" htmlFor={item.id}>{item.label}</Label>
                  <Input
                    type="checkbox"
                    id={item.id}
                    style={{ width: 20, height: 20, cursor: "pointer" }}
                    defaultChecked={!!validation.values[item.field]}
                    onChange={e => handleAgeChange(item.field, item.value, e.target.checked)}
                  />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>

      {/* Ticket Booking */}
      <Col className="border border-primary rounded p-3 bg-light">
        <CardBody>

          <div className="d-flex align-items-center gap-3 mb-3">
            <Switch
              className="me-1"
              disabled={!canEnableTicketBooking}
              onChange={checked => validation.setFieldValue("enableTicketBooking", checked)}
              checked={!!isBookingEnabled}
              onColor="#34c38f"
              offColor="#b3a692"
              uncheckedIcon={false}
              checkedIcon={false}
              height={16}
              width={32}
              handleDiameter={14}
            />
            <Label for="enableTicketBooking" className="mb-0 fw-semibold">
              Enable Ticket Booking
            </Label>
          </div>

          {!canEnableTicketBooking && (
            <div className="alert alert-warning d-flex align-items-center py-2 mb-3 border border-warning">
              <i className="mdi mdi-alert-outline me-2"></i>
              <small>Please select at least one Audience Type and Age Group to enable ticket booking.</small>
            </div>
          )}

          {isBookingEnabled && (
            <div className="p-3 border rounded bg-light bg-opacity-50">
              <Row className="g-3 mb-3">
                <Col md={4}>
                  <Label className="form-label fw-medium">Booking Type</Label>
                  <Input
                    type="select"
                    name="bookingType"
                    value={validation.values.bookingType || ""}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    className="form-select"
                  >
                    <option value="">Select Type</option>
                    <option value="ticket_booking">Ticket Booking</option>
                    <option value="food_booking">Food Booking</option>
                    <option value="ticket_food_booking">Ticket + Food Booking</option>
                  </Input>
                  {validation.touched.bookingType && validation.errors.bookingType && (
                    <div className="text-danger small mt-1">{validation.errors.bookingType}</div>
                  )}
                </Col>
                <Col md={4}>
                  <Label className="form-label fw-medium">Booking Opens On</Label>
                  <Input
                    type="datetime-local"
                    name="bookingOpen"
                    onBlur={validation.handleBlur}
                    min={new Date().toISOString().slice(0, 16)}
                    value={validation.values.bookingOpen || ""}
                    onChange={e => {
                      const openDate = e.target.value
                      const closeDate = validation.values.bookingClose
                      const earlyBird = validation.values.earlyBirdEndDate
                      validation.setFieldValue("bookingOpen", openDate)
                      if (closeDate && new Date(closeDate) < new Date(openDate)) {
                        validation.setFieldValue("bookingClose", "")
                      }
                      if (earlyBird && new Date(earlyBird) < new Date(openDate)) {
                        validation.setFieldValue("earlyBirdEndDate", "")
                      }
                    }}
                  />
                  {validation.touched.bookingOpen && validation.errors.bookingOpen && (
                    <div className="text-danger small mt-1">{validation.errors.bookingOpen}</div>
                  )}
                </Col>
                <Col md={4}>
                  <Label className="form-label fw-medium">Booking Closes On</Label>
                  <Input
                    type="datetime-local"
                    name="bookingClose"
                    value={validation.values.bookingClose || ""}
                    onBlur={validation.handleBlur}
                    min={validation.values.bookingOpen || ""}
                    onChange={e => {
                      const closeDate = e.target.value
                      const openDate = validation.values.bookingOpen
                      const earlyBird = validation.values.earlyBirdEndDate
                      if (openDate && new Date(closeDate) < new Date(openDate)) return
                      validation.setFieldValue("bookingClose", closeDate)
                      if (earlyBird && new Date(earlyBird) > new Date(closeDate)) {
                        validation.setFieldValue("earlyBirdEndDate", "")
                      }
                    }}
                  />
                  {validation.touched.bookingClose && validation.errors.bookingClose && (
                    <div className="text-danger small mt-1">{validation.errors.bookingClose}</div>
                  )}
                </Col>

              </Row>

              <Row className="g-3 align-items-center">

                <Col md={2} className="d-flex align-items-end">
                  <div className="d-flex justify-content-between align-items-center">
                    <Switch
                      onChange={checked => validation.setFieldValue("enable_early_bird", checked)}
                      checked={validation.values.enable_early_bird}
                      onColor="#ec8e09"
                      offColor="#b3a692"
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={16}
                      width={32}
                      handleDiameter={14}
                    />
                    <span className="fw-semibold ms-2">Enable Early Bird</span>

                  </div>
                </Col>

                {isEarlyBirdEnabled && (
                  <Col md={4}>
                    <Label className="form-label fw-medium " style={{ color: "#ec8e09" }}>
                      <i className="mdi mdi-bird me-1"></i>Early Bird End Date
                    </Label>
                    <Input
                     type="datetime-local"
  name="earlyBirdEndDate"
  // value={validation.values.earlyBirdEndDate || ""}
  value={
  validation.values.earlyBirdEndDate
    ? new Date(validation.values.earlyBirdEndDate)
        .toISOString()
        .slice(0, 16)
    : ""
}
  min={validation.values.bookingOpen || ""}
  max={validation.values.bookingClose || ""}
                      // type="date"
                      // name="earlyBirdEndDate"
                      // onBlur={validation.handleBlur}
                      // value={validation.values.earlyBirdEndDate || ""}
                      // min={validation.values.bookingOpen?.split("T")[0] || ""}
                      // max={validation.values.bookingClose?.split("T")[0] || ""}
                      onChange={e => {
                        const earlyBird = e.target.value
                        const open = validation.values.bookingOpen
                        const close = validation.values.bookingClose
                        if (open && new Date(earlyBird) < new Date(open)) return
                        if (close && new Date(earlyBird) > new Date(close)) return
                        validation.setFieldValue("earlyBirdEndDate", earlyBird)
                      }}
                    />
                    {validation.touched.earlyBirdEndDate && validation.errors.earlyBirdEndDate && (
                      <div className="text-danger small mt-1">{validation.errors.earlyBirdEndDate}</div>
                    )}
                  </Col>
                )}
              </Row>

              {(bookingType === "ticket_booking" || bookingType === "ticket_food_booking") && (
                <div className="mt-4 border-top border-primary pt-4">
                  <h6 className="fw-semibold mb-3">
                    <i className="mdi mdi-ticket-outline me-2 text-primary"></i>Ticket Booking Limit
                  </h6>
                  <Row className="g-3">
                    {validation.values.isMember && (
                      <Col md={4}>
                        <Label className="form-label fw-medium">Member Limit</Label>
                        <Input
                          type="number"
                          name="memberTicketLimit"
                          placeholder="e.g. 5"
                          value={validation.values.memberTicketLimit || ""}
                          min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                          onChange={validation.handleChange}
                        />
                        {validation.touched.memberTicketLimit && validation.errors.memberTicketLimit && (
    <div className="text-danger small">{validation.errors.memberTicketLimit}</div>
  )}
                      </Col>
                    )}
                    {validation.values.isNonMember && (
                      <Col md={4}>
                        <Label className="form-label fw-medium">Non Member Limit</Label>
                        <Input
                          type="number"
                          name="nonMemberTicketLimit"
                          placeholder="e.g. 5"
                          min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                          value={validation.values.nonMemberTicketLimit || ""}
                          onChange={validation.handleChange}
                        />
                        {validation.touched.nonMemberTicketLimit && validation.errors.nonMemberTicketLimit && (
    <div className="text-danger small">{validation.errors.nonMemberTicketLimit}</div>
  )}
                      </Col>
                    )}
                    {/* {validation.values.isSponsor && (
                      <Col md={4}>
                        <Label className="form-label small fw-medium">Sponsor Limit</Label>
                        <Input
                          type="number"
                          name="sponsorTicketLimit"
                          min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                          placeholder="e.g. 5"
                          value={validation.values.sponsorTicketLimit || ""}
                          onChange={validation.handleChange}
                        />
                          {validation.touched.sponsorTicketLimit && validation.errors.sponsorTicketLimit && (
    <div className="text-danger small">{validation.errors.sponsorTicketLimit}</div>
  )}
                      </Col>
                    )} */}
                  </Row>
                </div>
              )}

              {(bookingType === "food_booking" || bookingType === "ticket_food_booking") && (
                <div className="mt-4">
                  {foodCategories.includes("veg") && (
                    <div className="mb-4">
                      <h6 className="fw-semibold mb-3">
                        <span className="badge bg-success me-2">Veg</span>Food Limit
                      </h6>
                      <Row className="g-3">
                        {validation.values.isMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Member</Label>
                            <Input type="number" name="memberVegLimit" placeholder="e.g. 2"
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                             value={validation.values.memberVegLimit || ""}
                             onChange={validation.handleChange} />
                              {validation.touched.memberVegLimit && validation.errors.memberVegLimit && (
    <div className="text-danger small">{validation.errors.memberVegLimit}</div>
  )}
                          </Col>
                        )}
                        {validation.values.isNonMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Non Member</Label>
                            <Input type="number" name="nonMemberVegLimit" placeholder="e.g. 2" 
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.nonMemberVegLimit || ""} onChange={validation.handleChange} />
                             {validation.touched.nonMemberVegLimit && validation.errors.nonMemberVegLimit && (
    <div className="text-danger small">{validation.errors.nonMemberVegLimit}</div>
  )}
                          </Col>
                        )}
                        {/* {validation.values.isSponsor && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Sponsor</Label>
                            <Input type="number" name="sponsorVegLimit" placeholder="e.g. 2"
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.sponsorVegLimit || ""} onChange={validation.handleChange} />
                             {validation.touched.sponsorVegLimit && validation.errors.sponsorVegLimit && (
    <div className="text-danger small">{validation.errors.sponsorVegLimit}</div>
  )}
                          </Col>
                        )} */}
                      </Row>
                    </div>
                  )}
                  {foodCategories.includes("non_veg") && (
                    <div className="mb-4">
                      <h6 className="fw-semibold mb-3">
                        <span className="badge bg-danger me-2">Non-Veg</span>Food Limit
                      </h6>
                      <Row className="g-3">
                        {validation.values.isMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Member</Label>
                            <Input type="number" name="memberNonVegLimit" placeholder="e.g. 2"
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.memberNonVegLimit || ""} onChange={validation.handleChange} />
                               {validation.touched.memberNonVegLimit && validation.errors.memberNonVegLimit && (
    <div className="text-danger small">{validation.errors.memberNonVegLimit}</div>
  )}
                          </Col>
                        )}
                        {validation.values.isNonMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Non Member</Label>
                            <Input type="number" name="nonMemberNonVegLimit" placeholder="e.g. 2" 
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.nonMemberNonVegLimit || ""} onChange={validation.handleChange} />
                             {validation.touched.nonMemberNonVegLimit && validation.errors.nonMemberNonVegLimit && (
    <div className="text-danger small">{validation.errors.nonMemberNonVegLimit}</div>
  )}
                          </Col>
                        )}
                        {/* {validation.values.isSponsor && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Sponsor</Label>
                            <Input type="number" name="sponsorNonVegLimit" placeholder="e.g. 2" 
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.sponsorNonVegLimit || ""} onChange={validation.handleChange} />
                               {validation.touched.sponsorNonVegLimit && validation.errors.sponsorNonVegLimit && (
    <div className="text-danger small">{validation.errors.sponsorNonVegLimit}</div>
  )}
                          </Col>
                        )} */}
                      </Row>
                    </div>
                  )}
                  {foodCategories.includes("vegan") && (
                    <div className="mb-4">
                      <h6 className="fw-semibold mb-3">
                        <span className="badge bg-info me-2">Vegan</span>Food Limit
                      </h6>
                      <Row className="g-3">
                        {validation.values.isMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Member</Label>
                            <Input type="number" name="memberVeganLimit" placeholder="e.g. 2"
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.memberVeganLimit || ""} onChange={validation.handleChange} />
                             {validation.touched.memberVeganLimit && validation.errors.memberVeganLimit && (
    <div className="text-danger small">{validation.errors.memberVeganLimit}</div>
  )}
                          </Col>
                        )}
                        {validation.values.isNonMember && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Non Member</Label>
                            <Input type="number" name="nonMemberVeganLimit" placeholder="e.g. 2"
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.nonMemberVeganLimit || ""} onChange={validation.handleChange} />
                              {validation.touched.nonMemberVeganLimit && validation.errors.nonMemberVeganLimit && (
    <div className="text-danger small">{validation.errors.nonMemberVeganLimit}</div>
  )}
                          </Col>
                        )}
                        {/* {validation.values.isSponsor && (
                          <Col md={4}>
                            <Label className="form-label small fw-medium">Sponsor</Label>
                            <Input type="number" name="sponsorVeganLimit" placeholder="e.g. 2" 
                            min="1" // Add this
  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                            value={validation.values.sponsorVeganLimit || ""} onChange={validation.handleChange} />
                              {validation.touched.sponsorVeganLimit && validation.errors.sponsorVeganLimit && (
    <div className="text-danger small">{validation.errors.sponsorVeganLimit}</div>
  )}
                          </Col>
                        )} */}
                      </Row>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </CardBody>
      </Col>
    </>
  )
}

export default AudianceAndTicketing
